import * as g from "react";
const a = {
  instant: 0.075,
  // 75ms
  fast: 0.15,
  // 150ms
  normal: 0.25,
  // 250ms
  slow: 0.4,
  // 400ms
  slower: 0.6
  // 600ms
}, u = {
  inOut: [0.4, 0, 0.2, 1],
  out: [0, 0, 0.2, 1],
  in: [0.4, 0, 1, 1],
  spring: [0.34, 1.56, 0.64, 1],
  // Bouncy spring
  smooth: [0.25, 0.1, 0.25, 1]
  // Smooth natural
}, o = {
  style: "--ds-motion-style",
  durations: {
    instant: "--ds-motion-duration-instant",
    fast: "--ds-motion-duration-fast",
    normal: "--ds-motion-duration-normal",
    slow: "--ds-motion-duration-slow",
    slower: "--ds-motion-duration-slower"
  },
  easings: {
    inOut: "--ds-motion-ease-in-out",
    out: "--ds-motion-ease-out",
    in: "--ds-motion-ease-in",
    spring: "--ds-motion-ease-spring",
    smooth: "--ds-motion-ease-smooth"
  }
}, l = {
  style: "smooth",
  durations: a,
  easings: u
}, m = (n, e) => {
  if (!n) return e;
  const t = n.trim();
  if (t.endsWith("ms")) {
    const s = Number.parseFloat(t.replace("ms", ""));
    return Number.isFinite(s) ? s / 1e3 : e;
  }
  if (t.endsWith("s")) {
    const s = Number.parseFloat(t.replace("s", ""));
    return Number.isFinite(s) ? s : e;
  }
  const r = Number.parseFloat(t);
  return Number.isFinite(r) ? r > 10 ? r / 1e3 : r : e;
}, d = (n, e) => {
  if (!n) return e;
  const t = n.trim();
  if (t.startsWith("cubic-bezier")) {
    const s = t.slice(t.indexOf("(") + 1, t.lastIndexOf(")")).split(",").map((i) => Number.parseFloat(i.trim()));
    if (s.length === 4 && s.every((i) => Number.isFinite(i)))
      return [s[0], s[1], s[2], s[3]];
  }
  return e;
}, p = (n) => {
  if (typeof window > "u")
    return l;
  const e = n ?? document.documentElement;
  if (!e) return l;
  const t = getComputedStyle(e);
  return {
    style: t.getPropertyValue(o.style).trim() || l.style,
    durations: {
      instant: m(t.getPropertyValue(o.durations.instant), a.instant),
      fast: m(t.getPropertyValue(o.durations.fast), a.fast),
      normal: m(t.getPropertyValue(o.durations.normal), a.normal),
      slow: m(t.getPropertyValue(o.durations.slow), a.slow),
      slower: m(t.getPropertyValue(o.durations.slower), a.slower)
    },
    easings: {
      inOut: d(t.getPropertyValue(o.easings.inOut), [...u.inOut]),
      out: d(t.getPropertyValue(o.easings.out), [...u.out]),
      in: d(t.getPropertyValue(o.easings.in), [...u.in]),
      spring: d(t.getPropertyValue(o.easings.spring), [...u.spring]),
      smooth: d(t.getPropertyValue(o.easings.smooth), [...u.smooth])
    }
  };
}, y = (n) => {
  const e = n == null ? void 0 : n.scopeRef, [t, r] = g.useState(
    () => p((e == null ? void 0 : e.current) ?? void 0)
  );
  return g.useEffect(() => {
    if (typeof window > "u") return;
    const s = (e == null ? void 0 : e.current) ?? document.documentElement;
    if (!s) return;
    const i = () => r(p(s));
    i();
    const c = new MutationObserver(i);
    return c.observe(s, {
      attributes: !0,
      attributeFilter: ["style", "data-motion", "data-style"]
    }), () => c.disconnect();
  }, [e]), t;
}, f = l;
export {
  a as D,
  f as M,
  u as a,
  p as g,
  y as u
};
